export function contactPanel() {
    const toggleBtns = document.querySelectorAll("#toggleContactPanel");
    const closeBtn = document.getElementById("closeContactPanel");
    const contactPanel = document.querySelector(".contact-panel");
    const overlay = document.querySelector(".page-overlay");

    if (!toggleBtns.length || !contactPanel || !overlay) return;

    function openPanel() {
        contactPanel.classList.add("contact-panel--active");
        overlay.classList.add("page-overlay--active");
    }

    function closePanel() {
        contactPanel.classList.remove("contact-panel--active");
        overlay.classList.remove("page-overlay--active");
    }

    toggleBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            e.stopPropagation();
            openPanel();
        });
    });

    if (closeBtn) {
        closeBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            closePanel();
        });
    }

    document.addEventListener("click", (e) => {
        if (
            contactPanel.classList.contains("contact-panel--active") &&
            !contactPanel.contains(e.target) &&
            ![...toggleBtns].some(btn => btn.contains(e.target))
        ) {
            closePanel();
        }
    });

    overlay.addEventListener("click", closePanel);
}